import * as ko from "knockout"

export class TermsViewModel {
    showTerms = ko.observable<boolean>(false); 
}